/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminAsset
} from '.././model';

import adminV1OrganizationsAssetsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAssetsRetrieveMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssetsCreate = (
    organizationId: number,
    adminAsset: NonReadonly<AdminAsset>,
 options?: SecondParameter<typeof adminV1OrganizationsAssetsCreateMutator<AdminAsset>>,) => {
      return adminV1OrganizationsAssetsCreateMutator<AdminAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/assets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAsset
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsAssetsRetrieve = (
    organizationId: number,
    uuid: string,
 options?: SecondParameter<typeof adminV1OrganizationsAssetsRetrieveMutator<AdminAsset>>,) => {
      return adminV1OrganizationsAssetsRetrieveMutator<AdminAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/assets/${uuid}/`, method: 'GET'
    },
      options);
    }
  export type AdminV1OrganizationsAssetsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssetsCreate>>>
export type AdminV1OrganizationsAssetsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAssetsRetrieve>>>
